import { Component, inject, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/shared/user.service';

@Component({
  template: ''
})
export class LogoutComponent implements OnInit {
  private readonly userService = inject(UserService);

  ngOnInit() {
    this.userService.logout().subscribe(() => {
      location.reload(); // Reloading to clear all stored data (clientDetails etc)
    });
  }
}
